import React from 'react'
import ReactRating from 'react-rating'

import { Marble, MarbleColor } from './Marble'

export const MarbleRating = (props: any) => (
  <ReactRating
    className="MarbleRating"
    emptySymbol={<Marble color={MarbleColor.Empty} />}
    fullSymbol={<Marble color={MarbleColor.Green} />}
    {...props}
  />
)
